import { Component, OnInit } from '@angular/core';
import { Purchase } from '@df/interfaces';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { HandlerService } from '@app/_services/handler.service';
import { MarketService } from '@app/core/services/market.services';

@Component({
    selector: 'app-profile-purchases',
    templateUrl: './profile-purchases.component.html',
    styleUrls: ['./profile-purchases.component.scss']
})
export class ProfilePurchasesComponent implements OnInit {
    purchases: Array<Purchase>;
    countShow: number = 5;

    constructor(
        private marketService: MarketService,
        public dialog: MatDialog,
        private router: Router,
        private handlerService: HandlerService
    ) {}

    ngOnInit() {
        this.getUserPurchases();
    }

    private getUserPurchases(): void {
        this.marketService.getUserPurchases().subscribe(resp => {
            this.handlerService.checkErrors(resp);
            this.purchases = resp.data;
            this.getSummaryDealProducts();
        });
    }

    private getSummaryDealProducts(): void {
        this.purchases.forEach(it => {
            this.marketService.getSummaryDealProducts(it.product.id).subscribe(resp => {
                it.summary_product_count = resp;
            });
        });
    }

    loadNext(): void {
        this.countShow += 5;
    }

    showAll(): void {
        this.countShow = this.purchases.length;
    }

    openPreviw(purchase: Purchase): void {
        this.router.navigate([`profile/purchases/${purchase.id}`]);
    }
}
